import React from 'react';
import classes from './Categories.module.scss';

export const Categories = () => {
    return <div className={classes.Categories}>Категории</div>;
};
